import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { Formik, FormikHelpers } from "formik";
import { useQueryClient } from "react-query";
import { useState } from "react";
import { ChangeMachineLicensesFormValueType } from "./ChangeMachineLicensesForm";
import { DirtyFormPrompt } from "../../../../form/DirtyFormPrompt";
import { DisplayChangeMachineLicensesSummary } from "./DisplayChangeMachineLicenseSummary";
import { useChangeMachineLicenses } from "../../../../../hooks/machineLicenses/useChangeMachineLicenses";

type ChangeMachineLicensesSummaryProps = {
  machineLicensesFormValues?: ChangeMachineLicensesFormValueType;
  machineLicensesDisplayValues: any;
  callbackFn: (obj: any | undefined) => void;
  stepback: () => void;
  currentLicense:
  | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
  | undefined;
};
export const ChangeMachineLicensesSummary: React.FC<
  ChangeMachineLicensesSummaryProps
> = ({
  stepback,
  callbackFn,
  machineLicensesFormValues,
  machineLicensesDisplayValues,
  currentLicense
}) => {
    const [disableChangeAndSendEmailButton, setDisableChangeAndSendEmailButton] =
      useState(false);
    const queryClient = useQueryClient();
    const queryKey = "change-querylicensemanage";

    //const { t } = useTranslation();

    const changeLicenseAndSendEmail: any = useChangeMachineLicenses();

    const handleChangeMachineLicenses = async (
      values: any,
      formikHelpers: FormikHelpers<any>,
      options: {}
    ) => {
      console.log("VALUES ARE ", JSON.stringify(values))
      /**
       *   As per requirement by default we have to show Don't assign license switch button off in UI
       * but for backend we have to send true value for it.
       * so we will flip the value , whatever is shown in UI
       * if switch button off then send true
       * if switch button on then send false
       */
      // debugger;
      //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
      let newEntity:
        | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
        | undefined = await changeLicenseAndSendEmail({
          step: 3,
          email_address: currentLicense?.email_address ?? "",
          transaction_id: currentLicense?.transaction_id ?? "",
          language: currentLicense?.language ?? "",
          new_sub_start_date: currentLicense?.new_sub_start_date ?? undefined,
          new_subscription_code: currentLicense?.new_subscription_code ?? "",
          reduce_license_count: machineLicensesDisplayValues?.reduce_license_count,
          subscription_code: currentLicense?.subscription_code,
          new_license_count: currentLicense?.new_license_count
        });
      //   //console.log("newEntity",newEntity)
      console.log("JSON IS", newEntity);
      setDisableChangeAndSendEmailButton(false);
      callbackFn(newEntity);
    };
    const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
      setDisableChangeAndSendEmailButton(true);
      try {
        await onChangeMachineLicenses(values, formikHelpers, {});
      } catch (e) {
        console.log("Exception change License summary ", e);
      } finally {
        setDisableChangeAndSendEmailButton(false);
      }
    };

    const formSubmitToChangeMachineLicenses = () => {
      return [
        async (values: any, formikHelpers: FormikHelpers<any>) => {
          //debugger;
          return handleChangeMachineLicenses(values, formikHelpers, {});
        },
        {
          //  translationPrefix: "licenses.basic.detail.Change",
          // translationOptions: {
          //   batchnumber: 1,
          //        },
          translationPrefix: ["machinelicenses", "change"].join("."),
          onError: () => {
            // refetch entity from server
            queryClient.invalidateQueries(queryKey);
          },
        },
      ] as const;
    };

    const onChangeMachineLicenses = useFormSubmit(
      ...formSubmitToChangeMachineLicenses()
    );

    return (
      <FullWidthSpace direction="vertical" size="large">
        <Formik initialValues={{}} onSubmit={onSubmit} enableReinitialize>
          <div>
            <DirtyFormPrompt>
              <DisplayChangeMachineLicensesSummary
                stepback={stepback}
                machineLicensesDisplayValues={machineLicensesDisplayValues}
                machineLicensesFormValues={machineLicensesFormValues}
                disableChangeAndSendEmailButton={disableChangeAndSendEmailButton}
                currentLicense={currentLicense}
              />
            </DirtyFormPrompt>
          </div>
        </Formik>
      </FullWidthSpace >
    );
  };
